import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AuthTokenState {
    token: string | null
    isLoading: boolean
    error: string | null
    expiresAt: number | null
}

const initialState: AuthTokenState = {
    token: null,
    isLoading: false,
    error: null,
    expiresAt: null
}

const authTokenSlice = createSlice({
    name: 'authToken',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<{ token: string; expiresIn: number }>) => {
            state.token = action.payload.token
            state.expiresAt = Date.now() + action.payload.expiresIn * 1000
            state.isLoading = false
            state.error = null
        },
        clearToken: (state) => {
            state.token = null
            state.expiresAt = null
            state.error = null
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
            state.isLoading = false
        }
    }
})

export const { setToken, clearToken, setLoading, setError } = authTokenSlice.actions

const TOKEN_EXPIRY_BUFFER = 60 * 1000 // 60 seconds buffer before actual expiry

export const selectIsTokenExpired = (state: { authToken: AuthTokenState }): boolean => {
    const { expiresAt } = state.authToken
    if (!expiresAt) return true
    return Date.now() >= expiresAt - TOKEN_EXPIRY_BUFFER
}

export const selectTokenExpiresInMs = (state: { authToken: AuthTokenState }): number => {
    const { expiresAt } = state.authToken
    if (!expiresAt) return 0
    return Math.max(0, expiresAt - TOKEN_EXPIRY_BUFFER - Date.now())
}

export default authTokenSlice.reducer
